/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'react-dom',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./ToolbarDockDOMAPI',
	'./ToolbarDockComponent'
], function(React, ReactDOM, APIFactory, ToolbarDockDOMAPI, ToolbarDockComponent){
	class ToolbarDockDOM{
		constructor({ features }) {
			this._sections = {};
			this._providers = {};
			this._features = features;
		}

		initialize() {
			this._api = APIFactory.createAPI(this, [ToolbarDockDOMAPI]);

			const toolbarContainerEl = this._features.DashboardSettings.get('odtToolbarContainer');
			this._root = document.createElement('div');
			this._root.className = 'toolbarDockRoot';
			toolbarContainerEl.appendChild(this._root);
			return this.render();
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this._root && ReactDOM.unmountComponentAtNode(this._root);
			this._root && this._root.parentNode && this._root.parentNode.removeChild(this._root);
			delete this._api;
			delete this._providers;
			delete this._node;
		}

		/** API implementations */

		render() {
			return new Promise((resolve) => {
				ReactDOM.render(
					<ToolbarDockComponent
						toolbarDockDOM={this}
					/>,
					this._root,
					resolve
				);
			});
		}

		addProvider(providerID, provider) {
			this._providers[providerID] = provider;
			this.render();
		}

		removeProvider(providerID) {
			delete this._providers[providerID];
			this.render();
		}

		getProviders() {
			return this._providers;
		}
	}
	return ToolbarDockDOM;
});
